// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6982":"d6e954f5","7331":"d6e954f5"}[chunkId] + ".chunk.css";
};